/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class FlowchartViewIcon extends BaseIcon {
  getChildren = () => [
    <g fill={this.getColor()}>
      <rect width="5" height="16"/>
      <rect x="11" y="11" width="5" height="4.82"/>
      <rect x="11" width="5" height="8"/>
      <rect x="5" y="13" width="6" height="1"/>
      <rect x="5" y="3" width="6" height="1"/>
    </g>
  ]
  getViewBox = () => '0 0 16 16'
}
